module.exports = __webpack_public_path__ + "img/410-a7fc7f.png";